import LottieView from "lottie-react-native";
import { useEffect, useRef } from "react";
import { VStack } from "@gluestack-ui/themed";
import { LottieAnimationProps } from "./types";
import { DimensionValue } from "react-native";

export const LottieAnimation = ({
  file,
  height,
  width,
  duration,
  speed,
}: LottieAnimationProps) => {
  const animationRef = useRef<LottieView>(null);

  useEffect(() => {
    animationRef.current?.play(0, duration);
  }, [duration]);

  return (
    <VStack
      overflow="hidden"
      height={height as DimensionValue}
      width={width as DimensionValue}
      justifyContent="center"
      alignItems="center"
    >
      <LottieView ref={animationRef} source={file} speed={speed} />
    </VStack>
  );
};
